import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { LayersComparisonNodeModel } from '../../models';
import { useNodeComparisonForm } from '../../hooks';
import { ContractComparisonPanelsRenderer } from '..';
import './LayersComparisonRenderer.less';

interface Props {
    comparisonNode: LayersComparisonNodeModel;
}

const LayersComparisonRenderer: React.FC<Props> = ({ comparisonNode }) => {
    const { form, formKey, onValuesChange } = useNodeComparisonForm(
        comparisonNode.newNode,
        comparisonNode.previousNode
    );

    const getNewInputById = React.useCallback(
        (inputId: string) => comparisonNode.newLayer?.getInputById(inputId),
        [comparisonNode.newLayer]
    );

    const getPreviousInputById = React.useCallback(
        (inputId: string) => comparisonNode.previousLayer?.getInputById(inputId),
        [comparisonNode.previousLayer]
    );

    return (
        <div className="layers-comparison-renderer">
            <Form id={comparisonNode.nodeId} key={formKey} form={form} onValuesChange={onValuesChange}>
                <div className="layers-comparison-panels-container">
                    <ContractComparisonPanelsRenderer
                        nodeId={comparisonNode.nodeId}
                        panels={comparisonNode.panels}
                        contractChangeTracker={comparisonNode.contractChangeTracker}
                        getNewInputById={getNewInputById}
                        getPreviousInputById={getPreviousInputById}
                    />
                </div>
            </Form>
        </div>
    );
};

export default observer(LayersComparisonRenderer);
